import React from 'react';

import { Button } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { SadWolf } from 'ae-components/sad-wolf/sad-wolf';

import ErrorPage, { textColor } from '../error/error.page';

const UnavailablePage = () => {
  const { t } = useTranslation('insights');

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <ErrorPage
      data-testid="unavailable-page"
      title={t('unavailablePage.title')}
      backgroundImage="url(/images/404.png)"
      Icon={<SadWolf color={textColor} />}
      Button={
        <Button appearance="warning" onClick={refreshPage}>
          {t('unavailablePage.button')}
        </Button>
      }
    >
      {t('unavailablePage.content')}
    </ErrorPage>
  );
};

export default UnavailablePage;
